export default __webpack_public_path__ + "static/media/marvilop2.9e749c94.png";